module.exports = __webpack_public_path__ + "admin-thumbs/s-style-carousel.png";